import type { Block } from "../../contract"
import { Fold } from "../Fold"
import { Blocks } from "./Blocks"

/** Folded detail: a label that opens nested blocks. */
export function Disclosure({ label, blocks, path }: { label: string; blocks: Block[]; path: string }) {
  return (
    <Fold label={label}>
      <Blocks blocks={blocks} path={path} />
    </Fold>
  )
}
